<template>
  <div class="gallery w100 color-white">
    <div class="page-header">
      <div class="ImageTitle font12">ARTIST’S IMPRESSION</div>
    </div>
    <div class="bg-575252 w100 p-top-50 relative">
      <h2 class="Initial a98b59-color fontNormal font48 p-btm-50 p-top-50">
        GALLERY
      </h2>
      <div class="flex-center w60 m-auto galleryList" style="flex-wrap: wrap">
        <div
          v-for="(imgItme, i) in galleryImgList"
          :key="i"
          @click="openImg(imgItme, 1)"
          class="flex-column items-start galleryImg"
        >
          <div class="img-content">
            <img
              class="img-initial"
              style="width: 15vw; height: 15vw; object-fit: cover"
              :src="imgItme.path"
              alt=""
            />
            <p class="right">ARTIST'S IMPRESSION</p>
          </div>
          <p class="font14 light m-top-20">{{ imgItme.name }}</p>
        </div>
      </div>
      <img class="w100" src="@/assets/btn/line7.png" alt="" />
    </div>

    <div
      class="bg-575252 w100 p-top-50"
      style="padding-bottom: 120px !important"
    >
      <h2 class="Initial a98b59-color light font48 p-btm-50 p-top-50">
        VIDEOS
      </h2>
      <div
        class="w60 relative m-auto"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <swiper
          class="swiper swiperVideo w100"
          :options="swiperVideo"
          ref="swiperVideo"
        >
          <swiper-slide class="flex-center relative">
            <video
              ref="video1"
              playsinline
              @play="playType1 = false"
              @pause="playType1 = true"
              @ended="playType1 = true"
              poster="@/assets/video/video3.png"
              class="Initial"
              style="width: 100%; height: 100%; position: absolute"
              src="@/assets/video/video3.mp4"
            ></video>
            <div v-if="playType1 || (!playType1 && mouseType)" class="controls">
              <button @click="rewind(1)">
                <svg
                  t="1730445007352"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5506"
                  width="32"
                  height="32"
                >
                  <path
                    d="M981.333333 223.722667v570.197333c0 47.082667-33.28 66.496-74.346666 43.221333L401.984 550.976c-41.045333-23.253333-41.066667-61.013333 0-84.266667L906.986667 180.501333C948.010667 157.269333 981.333333 176.597333 981.333333 223.722667z m-558.293333 280.106666a41.173333 41.173333 0 0 0-7.232 4.992c1.706667 1.536 4.074667 3.242667 7.210667 5.034667L928.021333 800c12.608 7.146667 10.645333 8.32 10.645334-6.101333V223.722667c0-14.4 1.984-13.226667-10.666667-6.08L423.04 503.808z m195.989333-247.381333l-0.042666-9.045333c-0.106667-30.784-15.893333-39.914667-42.709334-24.725334L106.709333 488.768c-26.602667 15.061333-26.602667 31.957333 0 47.018667l469.546667 266.090666c26.794667 15.168 42.538667 5.973333 42.624-24.874666v-8.682667a21.333333 21.333333 0 1 1 42.666667 0.106667v8.682666c-0.149333 63.466667-51.093333 93.162667-106.304 61.866667L85.674667 572.928c-55.445333-31.402667-55.445333-89.856 0-121.258667l469.546666-266.090666c55.210667-31.274667 106.197333-1.728 106.453334 61.674666v9.045334a21.333333 21.333333 0 1 1-42.666667 0.170666z"
                    fill="#ffffff"
                    p-id="5507"
                  ></path>
                </svg>
              </button>
              <button v-if="playType1" @click="play(1)">
                <svg
                  t="1730444951954"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4795"
                  width="32"
                  height="32"
                >
                  <path
                    d="M675.328 117.717333A425.429333 425.429333 0 0 0 512 85.333333C276.352 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667 426.666667-191.018667 426.666667-426.666667c0-56.746667-11.093333-112-32.384-163.328a21.333333 21.333333 0 0 0-39.402667 16.341333A382.762667 382.762667 0 0 1 896 512c0 212.074667-171.925333 384-384 384S128 724.074667 128 512 299.925333 128 512 128c51.114667 0 100.8 9.984 146.986667 29.12a21.333333 21.333333 0 0 0 16.341333-39.402667zM456.704 305.92C432.704 289.152 405.333333 303.082667 405.333333 331.797333v360.533334c0 28.586667 27.541333 42.538667 51.370667 25.856l252.352-176.768c21.76-15.253333 21.632-43.541333 0-58.709334l-252.373333-176.768z m-8.597333 366.72V351.466667l229.269333 160.597333-229.269333 160.597333z"
                    fill="#ffffff"
                    p-id="4796"
                  ></path>
                </svg>
              </button>
              <button v-else @click="pause(1)">
                <svg
                  t="1730444977832"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5016"
                  width="32"
                  height="32"
                >
                  <path
                    d="M128 106.858667C128 94.976 137.621333 85.333333 149.12 85.333333h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333H149.12A21.290667 21.290667 0 0 1 128 917.141333V106.88z m640 0c0-11.882667 9.621333-21.525333 21.12-21.525334h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333h-85.76a21.290667 21.290667 0 0 1-21.12-21.525333V106.88z"
                    fill="#ffffff"
                    p-id="5017"
                  ></path>
                </svg>
              </button>
              <button @click="fastForward(1)">
                <svg
                  t="1730444993588"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5237"
                  width="32"
                  height="32"
                >
                  <path
                    d="M600.96 503.808L96 217.642667c-12.650667-7.168-10.666667-8.32-10.666667 6.08v570.197333c0 14.4-1.962667 13.248 10.666667 6.101333l504.96-286.165333c3.157333-1.792 5.546667-3.498667 7.232-5.034667a41.173333 41.173333 0 0 0-7.210667-5.013333zM42.666667 223.722667c0-47.146667 33.322667-66.453333 74.346666-43.2l505.002667 286.165333c41.066667 23.274667 41.045333 61.013333 0 84.266667L117.013333 837.162667C75.946667 860.416 42.666667 841.002667 42.666667 793.92V223.722667z m362.304 32.725333a21.333333 21.333333 0 1 1-42.666667-0.170667l0.042667-9.045333c0.234667-63.402667 51.221333-92.949333 106.410666-61.653333L938.325333 451.626667c55.445333 31.402667 55.445333 89.856 0 121.258666l-469.546666 266.090667c-55.232 31.274667-106.176 1.578667-106.325334-61.888v-8.682667a21.333333 21.333333 0 1 1 42.666667-0.106666v8.682666c0.085333 30.869333 15.829333 40.042667 42.602667 24.874667l469.568-266.090667c26.602667-15.061333 26.602667-31.957333 0-47.018666l-469.546667-266.090667c-26.837333-15.189333-42.624-6.058667-42.730667 24.725333l-0.042666 9.045334z"
                    fill="#ffffff"
                    p-id="5238"
                  ></path>
                </svg>
              </button>
            </div>
          </swiper-slide>
          <swiper-slide class="flex-center relative">
            <video
              ref="video2"
              playsinline
              @play="playType2 = false"
              @pause="playType2 = true"
              @ended="playType2 = true"
              poster="@/assets/gallery/_Novo RDR_Arrival Plaza_RGB_lr.jpg"
              class="Initial"
              style="width: 100%; height: 100%; position: absolute"
              src="@/assets/video/video2.mp4"
            ></video>
            <div v-if="playType2 || (!playType2 && mouseType)" class="controls">
              <button @click="rewind(2)">
                <svg
                  t="1730445007352"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5506"
                  width="32"
                  height="32"
                >
                  <path
                    d="M981.333333 223.722667v570.197333c0 47.082667-33.28 66.496-74.346666 43.221333L401.984 550.976c-41.045333-23.253333-41.066667-61.013333 0-84.266667L906.986667 180.501333C948.010667 157.269333 981.333333 176.597333 981.333333 223.722667z m-558.293333 280.106666a41.173333 41.173333 0 0 0-7.232 4.992c1.706667 1.536 4.074667 3.242667 7.210667 5.034667L928.021333 800c12.608 7.146667 10.645333 8.32 10.645334-6.101333V223.722667c0-14.4 1.984-13.226667-10.666667-6.08L423.04 503.808z m195.989333-247.381333l-0.042666-9.045333c-0.106667-30.784-15.893333-39.914667-42.709334-24.725334L106.709333 488.768c-26.602667 15.061333-26.602667 31.957333 0 47.018667l469.546667 266.090666c26.794667 15.168 42.538667 5.973333 42.624-24.874666v-8.682667a21.333333 21.333333 0 1 1 42.666667 0.106667v8.682666c-0.149333 63.466667-51.093333 93.162667-106.304 61.866667L85.674667 572.928c-55.445333-31.402667-55.445333-89.856 0-121.258667l469.546666-266.090666c55.210667-31.274667 106.197333-1.728 106.453334 61.674666v9.045334a21.333333 21.333333 0 1 1-42.666667 0.170666z"
                    fill="#ffffff"
                    p-id="5507"
                  ></path>
                </svg>
              </button>
              <button v-if="playType2" @click="play(2)">
                <svg
                  t="1730444951954"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4795"
                  width="32"
                  height="32"
                >
                  <path
                    d="M675.328 117.717333A425.429333 425.429333 0 0 0 512 85.333333C276.352 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667 426.666667-191.018667 426.666667-426.666667c0-56.746667-11.093333-112-32.384-163.328a21.333333 21.333333 0 0 0-39.402667 16.341333A382.762667 382.762667 0 0 1 896 512c0 212.074667-171.925333 384-384 384S128 724.074667 128 512 299.925333 128 512 128c51.114667 0 100.8 9.984 146.986667 29.12a21.333333 21.333333 0 0 0 16.341333-39.402667zM456.704 305.92C432.704 289.152 405.333333 303.082667 405.333333 331.797333v360.533334c0 28.586667 27.541333 42.538667 51.370667 25.856l252.352-176.768c21.76-15.253333 21.632-43.541333 0-58.709334l-252.373333-176.768z m-8.597333 366.72V351.466667l229.269333 160.597333-229.269333 160.597333z"
                    fill="#ffffff"
                    p-id="4796"
                  ></path>
                </svg>
              </button>
              <button v-else @click="pause(2)">
                <svg
                  t="1730444977832"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5016"
                  width="32"
                  height="32"
                >
                  <path
                    d="M128 106.858667C128 94.976 137.621333 85.333333 149.12 85.333333h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333H149.12A21.290667 21.290667 0 0 1 128 917.141333V106.88z m640 0c0-11.882667 9.621333-21.525333 21.12-21.525334h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333h-85.76a21.290667 21.290667 0 0 1-21.12-21.525333V106.88z"
                    fill="#ffffff"
                    p-id="5017"
                  ></path>
                </svg>
              </button>
              <button @click="fastForward(2)">
                <svg
                  t="1730444993588"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5237"
                  width="32"
                  height="32"
                >
                  <path
                    d="M600.96 503.808L96 217.642667c-12.650667-7.168-10.666667-8.32-10.666667 6.08v570.197333c0 14.4-1.962667 13.248 10.666667 6.101333l504.96-286.165333c3.157333-1.792 5.546667-3.498667 7.232-5.034667a41.173333 41.173333 0 0 0-7.210667-5.013333zM42.666667 223.722667c0-47.146667 33.322667-66.453333 74.346666-43.2l505.002667 286.165333c41.066667 23.274667 41.045333 61.013333 0 84.266667L117.013333 837.162667C75.946667 860.416 42.666667 841.002667 42.666667 793.92V223.722667z m362.304 32.725333a21.333333 21.333333 0 1 1-42.666667-0.170667l0.042667-9.045333c0.234667-63.402667 51.221333-92.949333 106.410666-61.653333L938.325333 451.626667c55.445333 31.402667 55.445333 89.856 0 121.258666l-469.546666 266.090667c-55.232 31.274667-106.176 1.578667-106.325334-61.888v-8.682667a21.333333 21.333333 0 1 1 42.666667-0.106666v8.682666c0.085333 30.869333 15.829333 40.042667 42.602667 24.874667l469.568-266.090667c26.602667-15.061333 26.602667-31.957333 0-47.018666l-469.546667-266.090667c-26.837333-15.189333-42.624-6.058667-42.730667 24.725333l-0.042666 9.045334z"
                    fill="#ffffff"
                    p-id="5238"
                  ></path>
                </svg>
              </button>
            </div>
          </swiper-slide>
        </swiper>
        <div
          class="swiper-pagination m-auto p-top-20"
          slot="pagination"
          style="left: 50%; transform: translateX(-50%)"
        ></div>
        <div class="swiper-button-prev" style="left: -15%; top: 45%">
          <img src="@/assets/btn/left.png" alt="" />
        </div>
        <div class="swiper-button-next" style="right: -15%; top: 45%">
          <img src="@/assets/btn/right.png" alt="" />
        </div>
      </div>
    </div>
    <div class="f1eee6-bg w100 color-black p-btm-20 p-top-50 relative">
      <h2 class="Initial a98b59-color light font48 p-btm-50 p-top-50">
        SALES GALLERY VIRTUAL TOUR
      </h2>
      <div class="w60 m-auto">
        <div class="flex-row w100 flex-row content-around cursor-pointer">
          <div
            class="flex1 font16 regular"
            v-for="(item, index) in galleryVRList"
            :key="index"
            :class="{ TabIndex: item.name == VrIndex.name }"
            @click="VrIndex = item"
          >
            {{ item.name }}
          </div>
          <!-- <div class="flex1 TabIndex" style="height: 35px">SALES GALLERY</div>
          <div class="flex1" style="height: 35px">3-BEDROOM + STUDY</div>
          <div class="flex1" style="height: 35px">4-BEDROOM + STUDY</div> -->
        </div>
        <div class="vrBox">
          <iframe
            class="w100 h100"
            :src="VrIndex.path"
            frameborder="0"
          ></iframe>
        </div>
      </div>
      <img class="w100" src="@/assets/btn/line6.png" alt="" />
    </div>

    <div class="f1eee6-bg w100">
      <h2 class="Initial a98b59-color light font48 p-btm-50 p-top-50">
        SHOW UNIT PHOTOS
      </h2>
      <div class="flex-center w60 m-auto galleryList" style="flex-wrap: wrap">
        <div
          v-for="(UnitItme, i) in UnitPhotosList"
          :key="i"
          @click="openImg(UnitItme, 2)"
          class="flex-column items-start galleryImg"
          style="width: 25%; margin: calc(25% / 6)"
        >
          <div class="img-content">
            <img
              class="img-initial"
              style="width: 15vw; height: 15vw; object-fit: cover"
              :src="UnitItme.path"
              alt=""
            />
            <p class="right">FOR ILLUSTRATION ONLY</p>
          </div>
          <p class="font14 regular m-top-20 color-black">{{ UnitItme.name }}</p>
        </div>
      </div>
    </div>
    <div
      v-if="ImgPopType"
      class="unit-pop fixed w100 h100 flex-center color-black"
      style="top: 0; left: 0; z-index: 1200"
    >
      <div
        class="w100 h100 pop-info p-btm-50"
        style="overflow: auto; background-color: white"
      >
        <div
          class="flex-row space-between m-auto items-center"
          style="height: 10%"
        >
          <div style="display: flex">
            <!-- <div class="triangle" :style="`border-top:100px solid ${nowUnit.color};`"></div> -->
            <h2 style="margin-left: 10px">{{ nowImg.name }}</h2>
          </div>
          <!-- <img style="margin: 10px;height: 80%;" src="@/assets/btn/logo.png" alt=""> -->
          <img
            @click="ImgPopType = false"
            style="margin-right: 20px"
            width="25px"
            height="25px"
            src="@/assets/208/close.png"
            alt=""
          />
        </div>
        <div @click="ImgPopType = false" class="w100 unit-img-group">
          <!-- <h2 style="margin-left: 10px;"></h2> -->
          <div class="img-content m-auto">
            <img
              @click.stop=""
              class="img-initial m-auto unit-img"
              :src="nowImg.path"
              alt=""
            />
            <p class="right" v-if="imgtype == 1">ARTIST'S IMPRESSION</p>
            <p class="right" v-else>FOR ILLUSTRATION ONLY</p>
          </div>
        </div>
        <img
          style="
            margin: 10px;
            height: 80%;
            position: absolute;
            bottom: 10px;
            right: 10px;
            width: 120px;
            height: auto;
          "
          src="@/assets/btn/logo.png"
          alt=""
        />
      </div>
    </div>
    <contant />
    <Footer />
  </div>
</template>


<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";
import swiper from "swiper";

export default {
  components: {
    Footer,
    contant,
  },
  data() {
    return {
      imgtype: 1,
      nowImg: {},
      ImgPopType: false,
      playType1: true,
      playType2: true,
      showControls: false,
      videoDiv: null,
      VrIndex: {
        name: "SALES GALLERY",
        path: "https://my.matterport.com/show/?m=d7XMw2p99dK",
      },
      VideoIndex: {},
      galleryImgList: [
        {
          name: "ARRIVAL PLAZA",
          path: require("@/assets/gallery/_Novo RDR_Arrival Plaza_RGB_lr.jpg"),
        },
        {
          name: "LIBRARY / WORK LOUNGE",
          path: require("@/assets/gallery/_Novo RDR_Library_RGB_lr.jpg"),
        },
        {
          name: "50M LAP POOL",
          path: require("@/assets/gallery/_Novo RDR_50m Lap Pool_RGB_lr.jpg"),
        },
        {
          name: "GYMNASIUM",
          path: require("@/assets/gallery/_Novo RDR_Gym_RGB_lr.jpg"),
        },
        {
          name: "THE DINING ROOM",
          path: require("@/assets/gallery/_Novo RDR_Gourmet Dining_RGB_lr.jpg"),
        },
        {
          name: "WELLNESS POOL",
          path: require("@/assets/gallery/_Novo RDR_Wellness Pool_RGB_lr.jpg"),
        },
        {
          name: "JACUZZI POOL",
          path: require("@/assets/gallery/_Novo RDR_Jacuzzi_RGB_lr.jpg"),
        },
        {
          name: "CLUB ROOM 1 AND 2",
          path: require("@/assets/gallery/_Novo RDR_Clubhouse Night_RGB_lr.jpg"),
        },
        {
          name: "CLUBHOUSE",
          path: require("@/assets/gallery/_Novo RDR_Clubhouse w Linear Park_RGB_lr.jpg"),
        },
        {
          name: "PLAYGROUND",
          path: require("@/assets/gallery/_Novo RDR_Playground_RGB_lr.jpg"),
        },
        {
          name: "KIDS’ PARTY ROOM",
          path: require("@/assets/gallery/_Novo RDR_Kids Party Room_RGB_lr.jpg"),
        },
        {
          name: "MAIN FACADE 1",
          path: require("@/assets/gallery/_Novo RDR_Hero Shot_RGB_lr.jpg"),
        },
        {
          name: "MAIN FACADE 2",
          path: require("@/assets/gallery/_Novo RDR_Aerial View_RGB_lr.jpg"),
        },
      ],
      galleryVRList: [
        {
          name: "SALES GALLERY",
          path: "https://my.matterport.com/show/?m=d7XMw2p99dK",
        },
        {
          name: "3-BEDROOM + STUDY",
          path: "https://my.matterport.com/show/?m=q2hGn3X7XLw",
        },
        {
          name: "4-BEDROOM + STUDY",
          path: "https://my.matterport.com/show/?m=ThVSLGUH2HX",
        },
      ],
      galleryVideoList: {
        0: {
          name: "VIDEO1",
          path: require("@/assets/gallery/_Novo RDR_Arrival Plaza_RGB_lr.jpg"),
          url: require("@/assets/video/video2.mp4"),
        },
        1: {
          name: "VIDEO2",
          path: require("@/assets/video/video3.png"),
          url: require("@/assets/video/video3.mp4"),
        },
      },
      UnitPhotosList: [
        {
          name: "LIVING ROOM",
          path: require("@/assets/gallery/_Novo Show Unit_Living Room_RGB_lr.jpg"),
        },
        {
          name: "KITCHEN",
          path: require("@/assets/gallery/_Novo Show Unit_Kitchen_RGB_lr.jpg"),
        },
        {
          name: "HOUSEHOLD SHELTER",
          path: require("@/assets/gallery/_Novo Show Unit_PD Door_RGB_lr.jpg"),
        },
        {
          name: "MASTER BEDROOM 1",
          path: require("@/assets/gallery/_Novo Show Unit_Bedroom_RGB_lr.jpg"),
        },
        {
          name: "WALK-IN WARDROBE",
          path: require("@/assets/gallery/_Novo Show Unit_Wardrobe_RGB_lr.jpg"),
        },
        {
          name: "MASTER BATH 1",
          path: require("@/assets/gallery/_Novo Show Unit_Bathroom_RGB_lr.jpg"),
        },
        {
          name: "MASTER BEDROOM 2",
          path: require("@/assets/gallery/_Novo Show Unit_Bedroom Flexi_RGB_lr.jpg"),
        },
        {
          name: "MASTER BATH 2",
          path: require("@/assets/gallery/_Novo Show Unit_Bathroom2_RGB_lr.jpg"),
        },
      ],
      swiperVideo: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 4, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        // loop:true,
        pagination: {
          el: ".swiper-pagination", //与分页器的类名绑定
          // type: 'progressbar', //选择分页器的类型（默认为小圆点）
          clickable: true, // 点击分页器跳切换到相应的幻灯片(不是所有分页器都支持)
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: function () {
            // const currentSlide = this.slides[this.activeIndex];
            // this.videoDiv = currentSlide.querySelectorAll('video')
            console.log(this.activeIndex);

            var el = document.querySelectorAll("video");
            el.forEach((video) => {
              video.pause(); // 暂停所有视频
            });
            // console.log('slide change');
            // console.log(this.realIndex);
            // console.log(this.activeIndex);
            // console.log(this.previousIndex);
            // console.log(this.previousRealIndex);
            // console.log(this.nextIndex);
            // console.log(this.nextRealIndex);
            // console.log(this.snapIndex);
          },
        },
      },
      mouseType: false,
    };
  },
  methods: {
    handleMouseEnter() {
      this.mouseType = true;
    },
    handleMouseLeave() {
      this.mouseType = false;
    },
    openImg(item, index) {
      this.imgtype = index;
      this.nowImg = item;
      this.ImgPopType = true;
    },
    play(index) {
      var videos = index == 1 ? this.$refs.video1 : this.$refs.video2;
      videos.play();
    },
    pause(index) {
      var videos = index == 1 ? this.$refs.video1 : this.$refs.video2;
      videos.pause();
    },
    rewind(index) {
      var videos = index == 1 ? this.$refs.video1 : this.$refs.video2;

      videos.currentTime -= 5; // 倒退5秒
    },
    fastForward(index) {
      var videos = index == 1 ? this.$refs.video1 : this.$refs.video2;

      videos.currentTime += 5; // 快进5秒
    },
  },
};
</script>

<style lang="less">
.gallery {
  margin-top: -56px;
  .page-header {
    height: calc(115vh - 110px);
    background-image: url("~@/assets/home/_Novo RDR_Aerial View_RGB_lr.jpg");
    background-size: cover;
    background-position-y: 70%;
    position: relative;
  }
  .controls {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    button {
      background-color: #faebd700;
      box-shadow: none;
      padding: 0;
      border: 0;
      margin: 0 4vw;
    }
  }
  .swiperVideo {
    height: 65vh;
  }
  .galleryList {
  }
  .galleryImg {
    width: 25%;
    margin: calc(25% / 6);
    .img-content {
      width: 100%;
    }
  }
  .swiper-pagination {
    display: flex;
  }
  .swiper-pagination-bullet-active {
    background-color: #a98b59 !important;
  }
  .swiper-pagination-bullet {
    width: 120px;
    border-radius: 2px;
    margin: 0 5px;
    border: 0;
    background-color: #f1eee6;
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      max-height: 2rem;
      max-width: 2rem;
    }
  }
  .TabIndex {
    font-weight: 500 !important;
  }
  .vrBox {
    width: 100%;
    height: 60vh;
  }
  .unit-img-group {
    height: calc(100% - 150px);
    // overflow: auto;
    .img-content {
      display: inline-block;
      height: 100%;
      img {
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
    }

  }
}

@media (max-width: 900px) {
  .gallery {
    .page-header {
      height: 30vh;
    }

    .unit-img-group {
      height: 80%;
      display: flex;
      .img-content {
        display: flex;
        height: auto;
        width: auto;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }

  .galleryList {
    flex-direction: column;
  }
  .galleryImg {
    width: 100% !important;
    margin: 0 !important;
    img {
      width: 100% !important;
      height: 200px !important;
    }
    .m-top-20 {
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  .vrBox {
    height: 45vh !important;
  }
  .swiperVideo {
    height: 45vh !important;
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: none !important;
  }
}
</style>









